(() => {
  if (window.deadvoidVideoBound) return;
  window.deadvoidVideoBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dv-video]');
    if (!button) return;
    const id = button.dataset.dvVideo;
    if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    iframe.title = button.getAttribute('aria-label') || 'Deadvoid Inc. official video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    iframe.tabIndex = 0;
    button.parentElement.replaceChildren(iframe);
    iframe.focus();
  });
})();
